/**
 * Auth version configuration.
 * V1: Uses /1.0/authorization (legacy token-based)
 * V2: Uses /2.0/auth/user/me (supports token + cookie-based auth)
 */
export const AUTH_VERSION = (process.env.NEXT_PUBLIC_AUTH_VERSION ?? 'v2') as 'v1' | 'v2';

export const isV2Auth = () => AUTH_VERSION === 'v2';
export const isV1Auth = () => AUTH_VERSION === 'v1';
